
import { Component, Vue } from 'vue-property-decorator'
import PersonCertificate from '@/components/register/PersonCertificate.vue'
import RegisterWrapper from '@/components/register/RegisterWrapper.vue'

@Component({
  components: {
    RegisterWrapper,
    PersonCertificate,
  }
})
export default class Certificate extends Vue {
  mounted() {
    if (this.$store.state.userData?.certifiedStatus === 'PENDING' ||
    this.$store.state.userData?.certifiedStatus === 'VERIFIED') {
      this.$router.push({ name: 'CertificateSuccess', query: this.$route.query })
    }
  }
}
